var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$screen.xl)?_c('div',[_vm._t("desktop")],2):(_vm.$screen.md)?_c('div',[_vm._t("tablet")],2):_c('div',[_vm._t("mobile")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }